import React from 'react'
import ReactDOM from 'react-dom';

const CardListHeader = (props) => {
  const { total, handleSort, handleSortDirection, sortOption, sortDirection } = props

  return (
    <div className="card-list-header">
      {/*TODO: replace this to real data*/}
      <div className="flex-row">
        <div className="col-md-7">
          <span className="cars-number"><strong>{total} Cars</strong> in tender</span>
        </div>
        <div className="col-md-5">
          <div className="row">
            <div className="col-md-8">
              <select value={sortOption} className="form-control white-back" onChange={handleSort}>
                <option value="mileage">Kilometre</option>
                <option value="year">Year</option>
                <option value="location">Location</option>
                <option value="end_time">Auction End</option>
              </select>
            </div>
            <div className="col-md-4">
              <select value={sortDirection} className="form-control white-back" onChange={handleSortDirection}>
                <option value="desc">&#x25bc;</option>
                <option value="asc">&#x25B2;</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default CardListHeader;
